export default __webpack_public_path__ + "static/media/logo.76e2de79.svg";